export const BaseLineUpscale = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.1421 2.87988H7.08934C4.76506 2.87988 2.88086 4.76408 2.88086 7.08836V16.9137C2.88086 19.238 4.76506 21.1222 7.08934 21.1222H16.9147C19.2389 21.1222 21.1231 19.238 21.1231 16.9137V10.8609"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12.7227 21.1226L12.7227 12.4803C12.7227 11.8175 12.1854 11.2803 11.5227 11.2803L2.88037 11.2803"
      stroke="currentColor"
      strokeDasharray="2.4 2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.46128"
    />
    <path d="M21.1211 3.00098V6.60097" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M20.4004 3.60107L15 9.00137" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M17.4 2.88184H21" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);
